@if (showBanner() && expiresAt(); as expires) {
    <div class="update-bar feature-access-expiry">
        <span [innerHTML]="'navbar.feature_access_expiring_soon' | translate: { date: expires * 1000 | date: 'longDate' }"></span>
        <span> — </span>
        <a [routerLink]="['/account/subscription-plan']" data-testid="topbar-feature-access-banner-plans-link">{{ "navbar.feature_access_view_plans" | translate }}</a>
        <button class="banner-dismiss-btn" (click)="dismiss()" aria-label="Dismiss" data-testid="topbar-feature-access-banner-dismiss-button">&#x2715;</button>
    </div>
}
